// Norwegian

export default {

  component: {
    jobAdList: {
      title: 'Åpne stillinger',
      jobs: 'jobber',
      noJobAds: 'Det er for tiden ingen ledige stillinger.',
    },

    jobAdCard: {
      openUntil: date => `Åpent til ${date}`,
    },

    jobAdGreetings: {
      thankYou: 'Mange takk.',
      readyInfo: 'Søknaden din er mottatt, og rekrutterer vil ta kontakt med deg om kort tid.',
      luck: 'Lykke til!',
    },

    jobAdSeeYou: {
      title: 'Mange takk.',
      description: 'Søknaden din er lagret og vi har sendt en link slik at du kan fortsette på den senere.',
    },

    unpublished: {
      title: 'Ikke publisert',
      info: 'Stillingsannonsen er ikke publisert ennå.',
    },
  },

  page: {},

}
